import React from 'react';
import I18n from 'i18n-js';
import { TCITooltip } from '@/components/ui/Tooltip';
import { ACTION_BAR_BTN_BG } from '../ActionBarButton/ActionBarButton';
import { CIRCLE_ICON_CLASS, ACTION_BAR_BTN_SHADOW } from '../../GoToButton';

type ActionBarLinkType = {
  href: string;
  tag: string
  icon: string;
  label?: string;
  dataMethod?: string;
  dataConfirm?: string;
  useNewTab?: boolean;
};

const ActionBarLink = ({ href, icon, label, tag, useNewTab = true, dataMethod, dataConfirm }: ActionBarLinkType) => (
  <TCITooltip>
    <TCITooltip.Trigger asChild>
      <a
        aria-label={label}
        className={CIRCLE_ICON_CLASS}
        data-confirm={dataConfirm}
        data-method={dataMethod}
        href={href}
        style={{ backgroundColor: ACTION_BAR_BTN_BG, boxShadow: ACTION_BAR_BTN_SHADOW }}
        target={useNewTab ? '_blank' : null}
      >
        <img
          aria-hidden
          alt=""
          className="tw-w-[1.5rem]"
          src={icon}
        />
      </a>
    </TCITooltip.Trigger>
    <TCITooltip.Content>
      {I18n.t(tag)}
    </TCITooltip.Content>
  </TCITooltip>
);
export default ActionBarLink;
